import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent implements OnInit {

  @Input() texto: string;
  @Input() determinado: boolean;
  @Input() textoIntermitente: boolean;
  @Input() style: any;

  constructor() { }

  ngOnInit() {
  }
}
